import { render, staticRenderFns } from "./rightInfo.vue?vue&type=template&id=62bad09b&scoped=true"
import script from "./rightInfo.vue?vue&type=script&lang=js"
export * from "./rightInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62bad09b",
  null
  
)

export default component.exports